export default {
    maxLength: 'maxlength',
};
